import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactDOM from "react-dom/client";

import { queryClient } from "./lib/api/queryClient";

import "./index.css";

import App from "./App";
import { ApiContextProvider, LoginContextProvider } from "./lib/api/common";

import "./i18n";

import theme from "./lib/theme/theme";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LoginContextProvider>
        <ApiContextProvider>
          <ChakraProvider theme={theme}>
            <App />
          </ChakraProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </ApiContextProvider>
      </LoginContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
